export default __webpack_public_path__ + "static/media/brandpool_v2.78d715ab.jpg";